export default __webpack_public_path__ + "static/media/logo.88538434.svg";